import { useState, useEffect } from 'react';
import { sanityClient } from '@/content/sanity/sanity-client/sanity-client';

export const useFetchPrompt = (): string | null => {
  const [promptText, setPromptText] = useState<string | null>(null);

  useEffect(() => {
    const query = `*[_type=="Prompts" && promptTitle=="clbcPrompt"][0]{ promptText }`;
    sanityClient
      .fetch(query)
      .then(data => {
        setPromptText(data?.promptText || null);
      })
      .catch(error => {
        console.error('Error fetching CLBC prompt:', error);
      });
  }, []);

  return promptText;
};
